module.exports = __webpack_public_path__ + "static/img/avatar_12.652d20e.png";


//////////////////
// WEBPACK FOOTER
// ./static/avatars/avatar_12.png
// module id = 1592
// module chunks = 61